export default "__VITE_ASSET__BIrGfd$t__"